import { createContext } from 'react';
import type { ThemeColor } from 'src/constants/theme-colors';

export interface ThemeConfig {
  color: string;
  colorFill: string;
  textColorClassName?: string;
  className: ThemeColor;
}

export interface ThemeContextValue {
  theme: string;
  setTheme: (theme: string) => void;
  config: ThemeConfig;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
